import script from "./CErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CErrorModal.vue?vue&type=script&setup=true&lang=ts"

import "./CErrorModal.vue?vue&type=style&index=0&id=6a77d1b1&lang=less"

const __exports__ = script;

export default __exports__